import { OptionPopperItem } from '../../../components/OptionPopper';
import { SVGIconDescriptor } from '../../../components/SVG';
import {
  FacetInfo,
  SearchHelpType,
} from '../../borrowed/catalog-app/typescript/src/app/model/types';

export const SEARCH_FACET_END_TOKEN = ':';
export const SEARCH_DELIMITER = ' ';

export type SuggestionType = 'help' | 'history' | 'catalog';
export interface SuggestionsProps {
  currentText?: string;
  selectionStartPosition?: number;
  selectionEndPosition?: number;
  currentSearchIndices?: Array<string>;
  enableExperimental: boolean;
  suggestionDisplayOrder: Array<SuggestionType>;
  helpUrls: Record<SearchHelpType, string | undefined> | undefined;
}

export type CatalogSuggestionSelectedEvent = {
  newInputString?: string; // if input string should be changed due to the selection
  datePickerSelected: boolean; // if date picker selected
  historySelected: boolean;
  historyIndices?: Array<string>;
  cursorOffset?: number; // the number of places the cursor should be moved from the end of the input string
};

export type SuggestionPopperItem = {
  suggestionType?: SuggestionType;
} & OptionPopperItem;

export type SuggestionInfo = {
  suggestions: Array<SuggestionPopperItem>;
  parseInfo?: SuggestionParseInfo;
  onSuggestionItemSelected: (suggestionEvent: {
    index: number;
  }) => CatalogSuggestionSelectedEvent | undefined;
};

export interface CatalogSearchHelp {
  label: string;
  helpId: SearchHelpType;
  icon: SVGIconDescriptor;
  iconAriaLabel: string | undefined;
  iconTooltip: string | undefined;
  example?: string;
}

export type GroupingTokenType = 'bracket' | 'paren' | 'quote' | 'curly' | 'none';

export const MUST_TOKEN = '+';
export const MUST_NOT_TOKEN = '-';
export type FacetModifier = typeof MUST_TOKEN | typeof MUST_NOT_TOKEN;

export type FacetParseInfo = {
  parentFacetInfo: FacetParseInfo | null;
  groupingTokenType: GroupingTokenType;
  facetModifier?: FacetModifier;
  acceptedValue: string;
} & FacetInfo;

export type CatalogSuggestionType = 'facet' | 'value';
export type SuggestionParseInfo = {
  startIndex: number;
  endIndex: number;
  value: string;
  parsedFacet: string;
  facetInfo: FacetParseInfo | null;
  suggestionType: CatalogSuggestionType;
};

export type FacetOrValueSuggestion = {
  value: string | null;
  label: string;
  icon?: SVGIconDescriptor;
  iconTooltip?: string;
  cursorOffset?: number;
};

// eslint-disable-next-line @sas/i18n/jsx-to-localize
export const PREVIOUS_DAY_SEARCH_VALUE = 'Previous day';

export const NESTED_FACET_SYNTAX_SUFFIX_LABEL = ' {  }';
export const NESTED_FACET_SYNTAX_SUFFIX_VALUE = ' {  }';
// -2 to place the cursor between the two curly braces with one space on either side
export const NESTED_FACET_CURSOR_OFFSET = -2;

export type SuggestionVisibility = 'always' | 'secondFocus' | 'never';
